import React from 'react';
import { TranslateHTML, useTranslate } from 'core/translate';
import Modal, {
  PEModalBody,
  ModalHeader,
} from '../../../components/modal/Modal';
import PriceWithNotification from '../../../common/notifications/PriceWithNotification';
import PaymentEstimatorUSForm from './PaymentEstimatorUSForm';
import PaymentEstimatorCAForm from './PaymentEstimatorCAForm';
import PaymentEstimatorTabs from './PaymentEstimatorTabs';
import { PriceWithConditionalNotification } from '../../../components/mathBox/Price';

const getMsrpDisplay = (msrp) => {
  const { employeePrice } = msrp;
  return {
    value: employeePrice,
    disclaimer: 'component.pe.msrp.employee.disclaimer',
    label: 'component.pricing.total.employee.msrp',
  };
};

const PaymentEstimatorSubheader = ({ bodyStyleTitle, config, params }) => {
  const translate = useTranslate();
  const { bodyType, style, selections, msrp } = config;
  const { normalizedNetPriceDisplay, employeePrice } = msrp;
  const { value, disclaimer } = employeePrice && getMsrpDisplay(msrp);

  const priceBox = employeePrice ? (
    <PriceWithNotification
      value={value}
      disclaimer={translate(disclaimer)}
      className="payment-adjust__header-price"
      useModal
    />
  ) : (
    <PriceWithConditionalNotification
      isNetPrice
      notificationName="msrp"
      useModal
      className="disclaimer payment-adjust__header-price">
      {normalizedNetPriceDisplay}
    </PriceWithConditionalNotification>
  );

  return (
    <div className="payment-adjust__title">
      <div className="payment-adjust__vehicle-string-header">
        <TranslateHTML
          className="payment-adjust__vehicle-string-header__year-body"
          value="pe.modal.vehicle.subheadline.year.and.model.v3"
          modelYear={params.modelyear}
          bodyStyle={bodyStyleTitle}
        />
        <TranslateHTML
          className="payment-adjust__vehicle-string-header__configurations"
          value="pe.modal.vehicle.subheadline.configuration.v3"
          driveType={selections.driveType}
          trim={style.trimName}
          config={bodyType.formattedConfig}
        />
      </div>
      <div className="payment-adjust__vehicle-price">
        <span className="payment-adjust__header-margin-msrp">{`${translate(
          'net.price.summary.v3'
        )}:`}</span>
        {priceBox}
      </div>
    </div>
  );
};

const PaymentEstimatorForm = ({ country, urls }) => {
  switch (country) {
    case 'US':
      return <PaymentEstimatorUSForm />;
    case 'CA':
      return <PaymentEstimatorCAForm urls={urls} />;
    default:
      return null;
  }
};

const PaymentEstimatorModal = (props) => {
  const {
    bodyStyleTitle,
    config,
    params,
    defaultTabIndex,
    onClose,
    urls,
    ctas,
  } = props;
  const translate = useTranslate();
  const header = translate('pe.modal.header.v3');

  return (
    <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
      <ModalHeader
        text={header}
        onClose={onClose}
        analyticsKey="estimate your payments"
      />
      <PEModalBody
        className="pe-modal__body"
        innerClassName="pe-modal__body__inner">
        <PaymentEstimatorSubheader
          bodyStyleTitle={bodyStyleTitle}
          config={config}
          params={params}
        />
        <div className="payment-adjust__container">
          <div className="payment-adjust__single-container payment-adjust__options-finance-details">
            <PaymentEstimatorForm country={params.country} urls={urls} />
          </div>
          <div className="tabs payment-adjust__container-details">
            <PaymentEstimatorTabs
              defaultTabIndex={defaultTabIndex}
              onClose={onClose}
              ctas={ctas}
            />
          </div>
        </div>
      </PEModalBody>
    </Modal>
  );
};

export default PaymentEstimatorModal;
